import { create } from 'zustand'
import { useAuthStore } from './auth'

/**
 * Файлы черновика по каналам. Чат пересоздаётся при смене канала (key={channelId}), и приложенные
 * картинки пропадали, хотя текст оставался (drafts.ts). Здесь файлы живут в памяти вкладки, пока
 * их не отправили или не убрали. Сам файл в localStorage не положить, поэтому перезагрузку они не
 * переживают — как и у Discord.
 */

export interface PendingFile {
  id: string
  file: File
  preview: string | null
  progress: number
  error: string | null
}

interface DraftFilesState {
  /** id канала → файлы; пустых списков нет. */
  files: Record<string, PendingFile[]>
  update: (channelId: string, fn: (prev: PendingFile[]) => PendingFile[]) => void
}

export const NO_FILES: PendingFile[] = []

/** Превью убранных и отправленных файлов больше не показывают — освобождаем память. */
function revokeGone(prev: PendingFile[], next: PendingFile[]) {
  for (const f of prev) if (f.preview && !next.some((n) => n.id === f.id)) URL.revokeObjectURL(f.preview)
}

export const useDraftFilesStore = create<DraftFilesState>((set) => ({
  files: {},
  update: (channelId, fn) =>
    set((s) => {
      const prev = s.files[channelId] ?? NO_FILES
      const next = fn(prev)
      if (next === prev) return s
      revokeGone(prev, next)
      const files = { ...s.files }
      if (next.length) files[channelId] = next
      else delete files[channelId]
      return { files }
    }),
}))

// другая учётная запись — чужие файлы в её черновиках не показываем
useAuthStore.subscribe((s, prev) => {
  if (s.user?.id === prev.user?.id) return
  for (const list of Object.values(useDraftFilesStore.getState().files)) revokeGone(list, NO_FILES)
  useDraftFilesStore.setState({ files: {} })
})
